module.exports = __webpack_public_path__ + "static/media/GT03_ST_Accommodation-Attributes.dd65fa92.csv";